import Woman from "../../../entities/Woman/ui/Woman";

const WomanPage = () => {
    return ( 
        <main>
            <Woman/>
        </main>
     );
}
 
export default WomanPage;